export default function lsGet(key) {
  try {
    return window.localStorage.getItem(key)
  } catch (_err) {
    return null
  }
}
